import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=9afadf82&scoped=true&"
import script from "./Social.vue?vue&type=script&lang=js&"
export * from "./Social.vue?vue&type=script&lang=js&"
import style0 from "./Social.vue?vue&type=style&index=0&id=9afadf82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afadf82",
  null
  
)

export default component.exports